import axios from 'axios';

const backend_url = process.env.REACT_APP_BACKEND_URL;
const axiosInstance = axios.create({
    baseURL: backend_url,
    timeout: 0,
    headers: {
        'Content-Type': 'application/json',
    },
});

export default axiosInstance;